import React, { createContext, useContext, useMemo, useState } from 'react';

type ProfileModalContextValue = {
  isOpen: boolean;
  openProfile: () => void;
  closeProfile: () => void;
};

const ProfileModalContext = createContext<ProfileModalContextValue | null>(null);

type ProfileModalProviderProps = {
  children: React.ReactNode;
};

export const ProfileModalProvider: React.FC<ProfileModalProviderProps> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const value = useMemo(
    () => ({
      isOpen,
      openProfile: () => setIsOpen(true),
      closeProfile: () => setIsOpen(false),
    }),
    [isOpen],
  );

  return <ProfileModalContext.Provider value={value}>{children}</ProfileModalContext.Provider>;
};

export const useProfileModal = () => {
  const context = useContext(ProfileModalContext);
  if (!context) {
    throw new Error('useProfileModal must be used within ProfileModalProvider');
  }
  return context;
};
